// ag-grid-react v25.3.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var counter = 0;
function generateNewKey() {
    return "agPortalKey_" + ++counter;
}
exports.default = generateNewKey;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ag-grid-react/lib/keyGenerator.js
// module id = 1027
// module chunks = 0